<template>
  <!----<Carousel class="new-home-slider">
    <Slide v-for="(slide, index) in homeSlider" :key="index">
      <div class="carousel__item">
        <div class="banner">
          <img :src="slide.image" alt="" class="w-100 zoom-out" />
          <div class="banner-text">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-8 col-md-10" data-aos="fade-up">
                  <h4>{{ translationText.text.homeName }}</h4>
                  <h1 v-html="translationText.text.homeDescription"></h1>
                  <router-link
                    :to="{ name: 'ShowDetails', params: { id: 1 } }"
                    class="btn btn-outline-wh"
                    >{{ translationText.text.readMore }}</router-link
                  >                  
                  <router-link to="/product" class="btn btn-dark">{{
                    translationText.text.shopNow
                  }}</router-link>                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Slide>

    <template #addons>
      <Navigation />
     
    </template>
  </Carousel>-->
  <div class="xmass-banner">
    <video src="/assets/images/christmas/banner.mp4" type=video/mp4 width="100%" style="height:auto !important;" loop="" muted="" playsinline="" autoplay=""></video>
 
    <div class="banner-contents-xmass">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2>{{ translationText.text.homeName }}</h2>
            <p>{{translationText.text.homeDescription}}</p>          
            <router-link to="/product" class="btn btn-dark">{{
              translationText.text.shopNow
            }}</router-link>
          
          </div>       
        
        </div>
      </div>
    </div>
    <div class="banner-announce">
            SUGAR FREE  |  GLUTEN FREE  |  NON GMO  |  SCIENCE BACKED
        </div>
  </div>

  <div class="featured-section">
        <div class="container">
            <div class="featured-band">
                <h5>{{ translationText.text.homeFeatureText }} :</h5>
                  <ul>
                    <li><img src="/assets/images/new_home/times.png" alt=""></li>
                    <li><img src="/assets/images/new_home/abnew.png" alt=""></li>
                    <li><img src="/assets/images/new_home/izona.png" alt=""></li>
                    <li><img src="/assets/images/new_home/trinity.png" alt=""></li>
                    <li><img src="/assets/images/new_home/thechronicle.png" alt=""></li>
                </ul>
            </div>
        </div>
  </div>
  
  <section class="shop-section">
        <div class="container">
            <div class="title-section text-center">
                <h2>Shop Our Best Sellers</h2>
            </div>
            <div class="row">
                <div class="col-lg-3 col-6 aos-init aos-animate" data-aos="fade-up">
                    <figure>
                        <a href="https://cymcorp.us/product/show/gsh-complex"><img alt="" class="w-100 radius20" src="/assets/images/new_home/product1.png"></a>
                    </figure>
                    <div class="product-description">
                        <h4><a href="https://cymcorp.us/product/show/gsh-complex"><span>GSH Complex</span></a></h4>
                        <div class="price-col">                            
                            <span class="price">$85.95</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-6 aos-init aos-animate" data-aos="fade-up">
                    <figure>
                        <a href="https://cymcorp.us/product/show/prezerv-derma"><img alt="" class="w-100 radius20" src="/assets/images/new_home/product2.png"></a>
                    </figure>
                    <div class="product-description">
                        <h4><a href="https://cymcorp.us/product/show/prezerv-derma"><span>PREZERV Derma</span></a></h4>
                        <div class="price-col">
                            <span class="price">$54.50</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-6 aos-init aos-animate" data-aos="fade-up">
                    <figure>
                        <a href="https://cymcorp.us/product/show/triozyme-chewables"><img alt="" class="w-100 radius20" src="/assets/images/new_home/product3.png"></a>
                    </figure>
                    <div class="product-description">
                        <h4><a href="https://cymcorp.us/product/show/triozyme-chewables"><span>Triozyme Chewables</span></a></h4>
                        <div class="price-col">                            
                            <span class="price">$59.95</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-6 aos-init aos-animate" data-aos="fade-up">
                    <figure>
                        <a href="https://cymcorp.us/product/show/une-vie"><img alt="" class="w-100 radius20" src="/assets/images/new_home/product4.png"></a>
                    </figure>
                    <div class="product-description">
                        <h4><a href="https://cymcorp.us/product/show/une-vie"><span>Une-Vie</span></a></h4>
                        <div class="price-col">
                            <span class="price">$35.35</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btnsection"><a href="https://cymcorp.us/product" class="btn custom-btn">VIEW ALL</a></div>
        </div>
    </section>
  
    
  
    
    <section class="lets-us-sec health-section">
        <div class="container">
            <div class="title-xmass">
                    <h2>We Can Help You Reach Your Health Goals</h2>
                    <h3>Supplier of Quality Life Products</h3>
                    <p>At Cymcorp, we believe that good health is a fundamental human right — not a privilege.</p>
                </div>
            <div class="row justify-content-center custom-row">
                

                <div class="col-lg-3 col-6 text-left mb-25">
                <figure><a href="https://cymcorp.us/product/show/cymslim"> <img alt="" class="w-100" src="/assets/images/new_home/help-img1.jpg"></a></figure>
                <a href="https://cymcorp.us/product/show/cymslim"><span>Weight Management</span></a>
                </div>

                <div class="col-lg-3 col-6 text-left mb-25">
                <figure><a href="https://cymcorp.us/product/show/triozyme-chewables"> <img alt="" class="w-100" src="/assets/images/new_home/help-img2.jpg"> </a></figure>
                <a href="https://cymcorp.us/product/show/triozyme-chewables"> <span>GUT HEALTH</span> </a>
                    </div>

                <div class="col-lg-3 col-6 text-left mb-25">
                <figure><a href="https://cymcorp.us/product/show/gsh-complex"> <img alt="" class="w-100" src="/assets/images/new_home/help-img3.jpg"> </a></figure>
                <a href="https://cymcorp.us/product/show/gsh-complex"> <span>Immune Support</span> </a>
                    </div>

                <div class="col-lg-3 col-6 text-left mb-25">
                <figure><a href="https://cymcorp.us/product/show/une-vie"> <img alt="" class="w-100" src="/assets/images/new_home/help-img4.jpg"></a></figure>
                <a href="https://cymcorp.us/product/show/une-vie"><span>Hydration</span> </a>
                </div>
                <div class="col-lg-3 col-6 text-left mb-25">
                <figure><a href="https://cymcorp.us/product/show/prezerv-derma"> <img alt="" class="w-100" src="/assets/images/new_home/help-img5.jpg"></a></figure>
                <a href="https://cymcorp.us/product/show/prezerv-derma"><span>Skin Health</span> </a>
                </div>

            </div>
        </div>
    </section>
       
    <section class="health-wellness-section">
        <div class="container">
            <div class="title-section text-center">
                <h2>Holistic Packages for Your Health and Wellness</h2>
            </div>
            <div class="row">
               <template v-for="(holistic,index) in holistic.products">
                 <div class="col-lg-4 col-6 aos-init aos-animate">
                   <figure>                      
                      <router-link
                      class="quick-view"
                      :to="{ name: 'ShowDetails', params: { id: holistic.id } }"
                      ><img :src="holistic.thumbnail_url" alt="" class="w-100 radius20"></router-link
                    >
                   </figure>
                   <div class="product-description">
                        <h4>
                          <router-link
                      
                      :to="{ name: 'ShowDetails', params: { id: holistic.id } }"
                      ><span>{{ holistic.name }}</span></router-link></h4>                      
                        <div class="price-col">
                        <template
                          v-if="
                            holistic.sale_price !=
                            holistic.suggested_retail_price
                          "
                        >
                      <span class="offer-price">${{ holistic.sale_price }}</span>
                      </template>
                            <span class="price">${{ holistic.suggested_retail_price }}</span>
                        </div>
                    </div>
              </div>               
            </template> 
            </div>
        </div>
    </section>

    <section class="product-review">
    <div class="container">
      <div class="row justify-content-center">
        <div class="title col-lg-7 text-center" data-aos="fade-up">
          <h5 v-html="peopleSaying.page_subheading"></h5>
          <h2 v-html="peopleSaying.name"></h2>
        </div>
        <div class="col-12" data-aos="fade-up">     
          <Splide
            aria-labelledby="video-example-heading"
            :options="options"
            :extensions="extensions"
          >
            <SplideSlide
              v-for="(id, index) in videos"
              :key="id"
              :data-splide-youtube="id"
            >
              <img
                :src="`https://i3.ytimg.com/vi/${id}/maxresdefault.jpg`"
                :alt="`YouTube Sample ${index + 1}`"
              />
            </SplideSlide>
          </Splide>

          <div class="btn-center text-center">
            <router-link :to="{ name: 'Testimonials' }" class="btn btn-dark">{{
              translationText.text.allReviews
            }}</router-link>
          </div>
        </div>
      </div>
    </div>
</section>     
  
  <section class="testimonial-slider">
    <div class="title-section text-center">
      <h2>Trusted By Experts</h2>
    </div>

    <div class="container-fluid">
      <Carousel
        paginationColor="gray"
        paginationActiveColor="red"
        :itemsToShow="1"
        class="stories-slider"
        :wrapAround="false"
        :transition="500"
      >
        <Slide v-for="(aslide, index) in expertsSlider" :key="index">
          <div class="carousel__item">
            <div class="testimonial-card">
              <div class="testimonial-thumb">
                <img :src="aslide.image" alt="" class="img-responsive" />
              </div>
              <div class="testimonial-text">
                <div class="client-sp">
                  <p>{{ aslide.description }}</p>
                </div>
                <div class="client-dl">
                  <div class="client-name">{{ aslide.name }}</div>
                  <p>{{ aslide.designation }}<br />{{ aslide.achievement }}</p>
                </div>
              </div>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Pagination />
        </template>
      </Carousel>
    </div>
  </section>

    
    
    <section class="gurantee-full-wrap new-full-about new-section-content p-0">
        <div class="barana-img-right"><img alt="" class="w-100" src="/assets/images/new_home/newbg1.jpg"></div>
            <div class="barana-text">
                <div class="container">
                    <div class="row">
                        <div class="col-md-5  aos-init aos-animate" data-aos="fade-right">
                        <h2>Support Natural Weight Management With GSH Complex & UneVie</h2>

                        <p>Emerging research suggests that maintaining a healthy immune system and staying well-hydrated may support your body’s natural weight management processes.</p>

                        <h3>Supports Immune Health</h3>
                            <p>GSH Complex helps maintain immune function, which is essential to overall well-being and a balanced lifestyle.</p>
                            <h3>Promotes Cellular Hydration</h3>
                            <p>UneVie Structured Water supports hydration, a key component in physical performance and metabolism.</p>
                            <h3>Encourages Natural Cleansing</h3>
                            <p>This combination may help support your body’s natural cleansing and elimination functions.</p>
                            <h3>Supports a Balanced Lifestyle</h3>
                            <p>Together, GSH Complex and UneVie offer nutritional support to help you stay on track with your wellness goals.</p>

                        <h5>Take control of your weight loss journey with the powerful GSH Complex and UneVie Combo. Transform your body today in just 7 days!</h5>
                    </div>
                </div>
            </div>
        </div>
    </section> 
</template>

<script setup>
import { defineComponent, ref, onMounted, defineProps, watch } from "vue";
import { storeToRefs } from "pinia";
import { Carousel, Pagination, Slide, Navigation } from "vue3-carousel";
import ProductListQuiz from "../components/Product/ProductListQuiz";
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import { Video } from "@splidejs/splide-extension-video";
import "@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css";
import { userLanguage } from "../stores/language";
import { useLoginStore } from "../stores/login";

const userLogin = useLoginStore();
const props = defineProps(["baseURL"]);
const videos = [
  "8B4fJZRkeOc",
  "YZ__M7qvPDI",
  "tsiCFTVemnA",
  "zgvm82FjfbE",
  "Vh98rKreIR0",
];
const userLanguages = userLanguage();
const { userCountry } = storeToRefs(userLogin);
const { languageCode } = storeToRefs(userLanguages);

const options = ref({
  rewind: true,
  type: "loop",
  perPage: 3,
  pagination: false,
  gap: "2em",
  breakpoints: {
    1199: {
      perPage: 2,
    },
    767: {
      perPage: 1,
    },
  },
  //heightRatio: 0.5625,
});
const extensions = ref({ Video });

const supplyQuality = ref("");
const naturalProduct = ref("");
const guarantee = ref("");
const peopleSaying = ref("");
const aboutCompany = ref("");
const helpYou = ref("");
const cymcorpHelpYou = ref("");
const realAthletesReview = ref("");
const cymcorpAcheivement = ref("");


const products = ref(
  {
    // products:{
    products: [],
  }
  //}
);

const holistic = ref({
    products: [],
  });

const translationTextEn = ref({
  text: {
    quickView: "QUICK VIEW",
    realStoryText: "Success Stories From Real People",
    readMore: "Read More",
    shopNow: "Shop Now",
    allReviews: "SEE ALL Reviews",
    readTestimonials: "Read More TESTIMONIALS",
    doscover: "Discover Our Latest Blogs",
    doscoverText:
      "Natural Immune System, Beauty Tips, The Newest Beauty Science Discoveries and More!",
    homeName: "Energy. Immunity. Balance.",
    homeDescription:
      "Vitality and immune support—made easy with Cymcorp.",
    homeFeatureText: "FEATURED IN",
    doscoverSliderName: "How to boost your immune system",
    doscoverSliderDescription:
      "On the whole, your immune system does a remarkable job of defending you against disease-causing microorganisms. But sometimes it fails: A germ invades successfully and makes you sick.",
    doscoverSliderName1: "10 reasons why hydration is important",
    doscoverSliderDescription1:
      "Staying hydrated is a simple yet critical part of maintaining good health. But most people just aren’t getting the fluids they need every day.",
    doscoverSliderName2: "Why gut health is important?",
    doscoverSliderDescription2:
      "The gut breaks down the foods you eat and absorbs nutrients that support your body's functions. Your gut is the foundation of everything.",
    storySliderDescription:
      "Greetings! I used the GSH eye wash and was pleased with how it felt. I'm curious if it might also be suitable for use in the ears. I experienced some changes in hearing following a fall some time ago and am looking into options for overall wellness support. Hope you can provide more information!",
    storySliderDescription1:
      "Two years ago, during my first pregnancy, I began experiencing occasional digestive discomfort that affected my sleep. Since I wanted to avoid using medications during pregnancy, I looked for a gentle, natural option. After consulting with my healthcare provider, I decided to try Triozyme. I noticed a difference in how I felt soon after starting it. Since then, my family and I have continued to use Triozyme to support our digestive wellness.",
    storySliderDescription2:
      "My name is Tom Carranco. I am 77 years old and have been taking Viprox since before October 2018. I believe that maintaining my supplement routine, including Viprox, has supported my overall well-being. After a challenging experience during a hospital visit, I noticed that my general recovery and vitality remained strong. I continue to take Viprox and feel it helps support my energy and overall health.",    
  },
  language: "",
});


const translationText = ref({
  text: {
    quickView: "QUICK VIEW",
    realStoryText: "Success Stories From Real People",
    readMore: "Read More",
    shopNow: "Shop Now",
    allReviews: "SEE ALL Reviews",
    readTestimonials: "Read More TESTIMONIALS",
    doscover: "Discover Our Latest Blogs",
    doscoverText:
      "Natural Immune System, Beauty Tips, The Newest Beauty Science Discoveries and More!",
    homeName: "Energy. Immunity. Balance.",
    homeDescription:
      "Vitality and immune support—made easy with Cymcorp.",
    homeFeatureText: "FEATURED IN",
    doscoverSliderName: "How to boost your immune system",
    doscoverSliderDescription:
      "On the whole, your immune system does a remarkable job of defending you against disease-causing microorganisms. But sometimes it fails: A germ invades successfully and makes you sick.",
    doscoverSliderName1: "10 reasons why hydration is important",
    doscoverSliderDescription1:
      "Staying hydrated is a simple yet critical part of maintaining good health. But most people just aren’t getting the fluids they need every day.",
    doscoverSliderName2: "Why gut health is important?",
    doscoverSliderDescription2:
      "The gut breaks down the foods you eat and absorbs nutrients that support your body's functions. Your gut is the foundation of everything.",
    storySliderDescription:
      "Greetings! I used the GSH eye wash and was pleased with how it felt. I'm curious if it might also be suitable for use in the ears. I experienced some changes in hearing following a fall some time ago and am looking into options for overall wellness support. Hope you can provide more information!",
    storySliderDescription1:
      "Two years ago, during my first pregnancy, I began experiencing occasional digestive discomfort that affected my sleep. Since I wanted to avoid using medications during pregnancy, I looked for a gentle, natural option. After consulting with my healthcare provider, I decided to try Triozyme. I noticed a difference in how I felt soon after starting it. Since then, my family and I have continued to use Triozyme to support our digestive wellness.",
    storySliderDescription2:
      "My name is Tom Carranco. I am 77 years old and have been taking Viprox since before October 2018. I believe that maintaining my supplement routine, including Viprox, has supported my overall well-being. After a challenging experience during a hospital visit, I noticed that my general recovery and vitality remained strong. I continue to take Viprox and feel it helps support my energy and overall health.",    
  },
  language: "",
});

const homeSlider = ref([
  {
    image: "/assets/images/Home-Banner.jpg",
  },
  {
    image: "/assets/images/UNIVIE-banner4.jpg",
  },
  {
    image: "/assets/images/Triozyme-banner3.jpg",
  },
  {
    image: "/assets/images/Immunity-banner2.jpg",
  },
]);
const silder = ref([
  "/assets/images/review-img1.jpg",
  "/assets/images/review-img2.jpg",
  "/assets/images/review-img3.jpg",
  "/assets/images/review-img3.jpg",
]);
const storySilder = ref([
  {
    name: "Elaine J.",
    description:
      "Greetings! I used the GSH eye wash and was pleased with how it felt. I'm curious if it might also be suitable for use in the ears. I experienced some changes in hearing following a fall some time ago and am looking into options for overall wellness support. Hope you can provide more information!",
    image: "/assets/images/quote.png",
    video: "https://youtu.be/8B4fJZRkeOc",
  },
  {
    name: "Carolyn T.",
    description:
      "Two years ago, during my first pregnancy, I began experiencing occasional digestive discomfort that affected my sleep. Since I wanted to avoid using medications during pregnancy, I looked for a gentle, natural option. After consulting with my healthcare provider, I decided to try Triozyme. I noticed a difference in how I felt soon after starting it. Since then, my family and I have continued to use Triozyme to support our digestive wellness.",
    image: "/assets/images/quote.png",
    video: "https://youtu.be/8B4fJZRkeOc",
  },
  {
    name: "Thomas Carranco",
    description:
      "My name is Tom Carranco. I am 77 years old and have been taking Viprox since before October 2018. I believe that maintaining my supplement routine, including Viprox, has supported my overall well-being. After a challenging experience during a hospital visit, I noticed that my general recovery and vitality remained strong. I continue to take Viprox and feel it helps support my energy and overall health.",
    image: "/assets/images/quote.png",
    video: "https://youtu.be/8B4fJZRkeOc",
  },
]);
const discoverSilder = ref([
  {
    dateTime: "22 July, 23",
  },
  {
    dateTime: "01 August, 23",
  },
  {
    dateTime: "15 September, 23",
  },
]);

const athletesSlider = ref([
      {
        name: "Sean McColl, Canada",
        designation: "Professional Rock Climber, Sports Climbing (Bouldering, Lead, Combined)",
        acheivemenet: "8 times world champion",
        description:
          "“NexPro Cell Tech is my first and ONLY fitness supplement, I use it every day and could feel the benefits in under 2 weeks. I recently came back from a French Cup in Valence and I felt like everything clicked at the competition. I felt like I had extra energy, I had trained well and I can only think of the supplements I've been taking. I think my body is really liking it. Une-Vie is the product I take every morning alongside my GSH Whey Protein. It hydrates me every day and promotes better nutrient absorption.”",
        image: "/assets/images/athalatics-img.png"
      },
      {
        name: "Maggy Dubé-Laroche, Canada",
        designation: "Sport Climber",
        acheivemenet: "Canadian Champion (Speed Climbing)",
        description:
          "“NexPro Cell Tech is the only fitness supplements in my daily routine. Since adding the GSH Complex immunity supplement and Une Vie Hydrating solution to my routine, I’ve noticed a huge difference. I feel more energized during workouts, recover faster, and haven’t had to worry about getting sick as often.”",
        image: "/assets/images/athalatics-img2.png"
      },
]);

const expertsSlider = ref([
{
    image: "/assets/images/new_home/testimonial1.jpg",
    description:
      "As an elite athlete and new mom, staying hydrated has never been more important. During my pregnancy and postpartum recovery, Une Vie Structured Water was a game-changer. It helped me bounce back faster, feel more energized, and stay on top of my performance—even through the toughest days. I truly felt the difference.",
    name: "Kate Hall",
    designation: "ASICS Long Jumper",
    achievement: "Two-Time NCAA D1 Champion",
  },
  {
    image: "/assets/images/new_home/testimonial2.jpg",
    description:
      "Une-Vie is the product I take every morning alongside my GSH Whey Protein. It hydrates me every day and promotes better nutrient absorption. I recently came back from a French Cup in Valence and I felt like everything clicked at the competition. I felt like I had extra energy, I had trained well and I can only think of the supplements I've been taking. I think my body is really liking it.",
    name: "Sean McColl, Canada",
    designation: "Professional Rock Climber",
    achievement: "8 times world champion",
  },
  {
    image: "/assets/images/new_home/testimonial3.jpg",
    description:
      "NexPro Cell Tech is the only fitness supplements in my daily routine. Since adding the GSH Complex immunity supplement and Une Vie Hydrating solution to my routine, I’ve noticed a huge difference. I feel more energized during workouts, recover faster, and haven’t had to worry about getting sick as often.",
    name: "Maggy Dubé-Laroche, Canada",
    designation: "Sport Climber",
    achievement: "Canadian Champion (Speed Climbing)",
  },
]);

const fetchDataFromAPI = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const reqUserType = userLogin.checkUserType
    ? "/" + userLogin.checkUserType
    : "/" + "customer";
  const apiUrl = props.baseURL + "products" + reqUserType + languageUrl;
  //
  console.log("home product api url ", apiUrl);
  axios
    .get(apiUrl)
    .then((response) => {
      products.value = response.data;
      console.log(response.data);
      //console.log("product data",this.products.products.length);
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

const fetchDataFromAPIHolistic  = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const reqUserType = userLogin.checkUserType
    ? "/" + userLogin.checkUserType
    : "/" + "customer";
  const apiUrl = props.baseURL + "products/holistic" + reqUserType + languageUrl;
  //const apiUrl = "https://cymcorp.us/management/api/v1/" + "products/holistic" + reqUserType + languageUrl;
  
  //
  console.log("home product api url ", apiUrl);
  axios
    .get(apiUrl)
    .then((response) => {
      holistic.value = response.data;
      console.log(response.data);
      //console.log("product data",this.products.products.length);
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};


const getSupplyQuality = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const apiUrl =
    props.baseURL + "page/supplier-of-true-quality-life-products" + languageUrl;

  axios
    .get(apiUrl)
    .then((response) => {
      if (response.data.page_details.length > 0) {
        supplyQuality.value = response.data.page_details[0];
      } else {
        supplyQuality.value = "";
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

const getNaturalProduct = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const apiUrl =
    props.baseURL +
    "page/our-products-are-developed-by-experienced-team" +
    languageUrl;

  axios
    .get(apiUrl)
    .then((response) => {
      if (response.data.page_details.length > 0) {
        naturalProduct.value = response.data.page_details[0];
      } else {
        naturalProduct.value = "";
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

const guaranteed = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const apiUrl = props.baseURL + "page/guaranteed" + languageUrl;

  axios
    .get(apiUrl)
    .then((response) => {
      if (response.data.page_details.length > 0) {
        guarantee.value = response.data.page_details[0];
      } else {
        guarantee.value = "";
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

const getPeopleSaying = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const apiUrl =
    props.baseURL +
    "page/see-what-real-people-are-saying-about-our-products" +
    languageUrl;

  axios
    .get(apiUrl)
    .then((response) => {
      if (response.data.page_details.length > 0) {
        peopleSaying.value = response.data.page_details[0];
      } else {
        peopleSaying.value = "";
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

const getAboutCompany = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const apiUrl = props.baseURL + "page/about-our-company" + languageUrl;

  axios
    .get(apiUrl)
    .then((response) => {
      if (response.data.page_details.length > 0) {
        aboutCompany.value = response.data.page_details[0];
      } else {
        aboutCompany.value = "";
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

const getQuizeText = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const apiUrl =
    props.baseURL +
    "page/we-can-help-you-by-guiding-you-to-a-good-solid-health" +
    languageUrl;

  axios
    .get(apiUrl)
    .then((response) => {
      if (response.data.page_details.length > 0) {
        helpYou.value = response.data.page_details[0];
      } else {
        helpYou.value = "";
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};
const getCymcorpHelpYouText = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const apiUrl =
    props.baseURL +
    "page/how-can-cymcorp-help-you" +
    languageUrl;

  axios
    .get(apiUrl)
    .then((response) => {
      if (response.data.page_details.length > 0) {
        cymcorpHelpYou.value = response.data.page_details[0];
      } else {
        cymcorpHelpYou.value = "";
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};
const getRealAthletesReviewText = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const apiUrl =
    props.baseURL +
    "page/real-athletes-review" +
    languageUrl;

  axios
    .get(apiUrl)
    .then((response) => {
      if (response.data.page_details.length > 0) {
        realAthletesReview.value = response.data.page_details[0];
      } else {
        realAthletesReview.value = "";
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};
const getCymcorpAcheivementText = async () => {
  const languageUrl = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  const apiUrl =
    props.baseURL +
    "page/cymcorp-acheivement" +
    languageUrl;

  axios
    .get(apiUrl)
    .then((response) => {
      if (response.data.page_details.length > 0) {
        cymcorpAcheivement.value = response.data.page_details[0];
      } else {
        cymcorpAcheivement.value = "";
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};



const onReady = async () => {
  this.$refs.youtube.playVideo();
};

const translatText = () => {
  // console.log(props.baseURL);
  // const languageUrl = userLanguages.getLanguageCode
  //   ? "/" + userLanguages.getLanguageCode
  //   : "";
  translationTextEn.value.language = userLanguages.getLanguageCode
    ? "/" + userLanguages.getLanguageCode
    : "";
  if(userLanguages.getLanguageCode != 'en'){

    const apiUrl = props.baseURL + "translateany";
    axios
      .post(apiUrl, translationTextEn.value)
      .then((response) => {
        console.log("response trnasate :", response.data);
        translationText.value = response.data;
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }
  else{
        translationText.value = translationTextEn.value;
  }
  
};

watch(languageCode, () => {
  fetchDataFromAPI();
  getSupplyQuality();
  getNaturalProduct();
  guaranteed();
  getPeopleSaying();
  getAboutCompany();
  getQuizeText();
  getCymcorpHelpYouText();
  getRealAthletesReviewText();
  translatText();
  fetchDataFromAPIHolistic();
  getCymcorpAcheivementText();
});

watch(userCountry, () => {
  console.log("isLoggedIn ref changed, do something!");
  console.log("userLanguages.getLanguageCode", userLanguages.getLanguageCode);
  fetchDataFromAPI();
  getSupplyQuality();
  getNaturalProduct();
  guaranteed();
  getPeopleSaying();
  getAboutCompany();
  getQuizeText();
  getCymcorpHelpYouText();
  getRealAthletesReviewText();
  translatText();
  fetchDataFromAPIHolistic();
  getCymcorpAcheivementText();
});

onMounted(() => {
  fetchDataFromAPIHolistic();
  fetchDataFromAPI();
  getSupplyQuality();
  getNaturalProduct();
  guaranteed();
  getPeopleSaying();
  getAboutCompany();
  getQuizeText();
  getCymcorpHelpYouText();
  getRealAthletesReviewText();
  getCymcorpAcheivementText();
  translatText();
});
</script>
